module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8017.d44c02a5.png";